import { render, staticRenderFns } from "./journalmanage.vue?vue&type=template&id=45b0aba5&scoped=true&"
import script from "./journalmanage.vue?vue&type=script&lang=js&"
export * from "./journalmanage.vue?vue&type=script&lang=js&"
import style0 from "./journalmanage.vue?vue&type=style&index=0&id=45b0aba5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b0aba5",
  null
  
)

export default component.exports